import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./AdminPopUps.css";

export default function AdminPopUps() {
    const [popups, setPopups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editando, setEditando] = useState(null);

    // ======================
    // FORM EDITAR
    // ======================
    const [form, setForm] = useState({
        tipo: "PC",
        fechaInicio: "",
        fechaFin: ""
    });

    // ======================
    // MODAL CREAR
    // ======================
    const [showCrear, setShowCrear] = useState(false);
    const [tipoNuevo, setTipoNuevo] = useState("pc");
    const [imagen, setImagen] = useState(null);
    const [preview, setPreview] = useState(null);
    const [fechaInicioNuevo, setFechaInicioNuevo] = useState("");
    const [fechaFinNuevo, setFechaFinNuevo] = useState("");

    // ======================
    // LISTAR
    // ======================
    const cargarPopups = async () => {
        setLoading(true);
        try {
            const res = await fetch(process.env.REACT_APP_API_POPUP_LISTAR);
            if (res.ok) setPopups(await res.json());
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarPopups();
    }, []);

    // ======================
    // EDITAR
    // ======================
    const abrirEdicion = (popup) => {
        setEditando(popup.id);
        setForm({
            tipo: popup.tipo,
            fechaInicio: popup.fechaInicio?.substring(0, 10),
            fechaFin: popup.fechaFin?.substring(0, 10)
        });
    };

    const guardarEdicion = async () => {
        try {
            const res = await fetch(process.env.REACT_APP_API_POPUP_EDITAR, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: editando,
                    ...form
                })
            });

            if (!res.ok) throw new Error();

            Swal.fire("Actualizado", "Popup modificado", "success");
            setEditando(null);
            cargarPopups();
        } catch {
            Swal.fire("Error", "No se pudo guardar", "error");
        }
    };

    // ======================
    // ELIMINAR (BODY)
    // ======================
    const eliminarPopup = async (id) => {
        const confirm = await Swal.fire({
            title: "¿Eliminar popup?",
            icon: "warning",
            showCancelButton: true
        });

        if (!confirm.isConfirmed) return;

        try {
            const res = await fetch(process.env.REACT_APP_API_POPUP_ELIMINAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id })
            });

            if (!res.ok) throw new Error();

            Swal.fire("Eliminado", "Popup eliminado", "success");
            cargarPopups();
        } catch {
            Swal.fire("Error", "No se pudo eliminar", "error");
        }
    };

    // ======================
    // CREAR POPUP (VIEJO)
    // ======================
    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImagen(file);
        setPreview(URL.createObjectURL(file));
    };

    const crearPopup = async () => {
        if (!imagen || !fechaInicioNuevo || !fechaFinNuevo) {
            Swal.fire("Faltan datos", "", "warning");
            return;
        }

        const imagenBase64 = await toBase64(imagen);
        const formData = new FormData();

        formData.append("ImagenBase64", imagenBase64);
        formData.append("Tipo", tipoNuevo);
        formData.append("FechaInicio", fechaInicioNuevo);
        formData.append("FechaFin", fechaFinNuevo);

        try {
            const res = await fetch(process.env.REACT_APP_API_POPUP_SUBIR, {
                method: "POST",
                body: formData
            });

            if (!res.ok) throw new Error();

            Swal.fire("Creado", "Popup cargado", "success");
            setShowCrear(false);
            setImagen(null);
            setPreview(null);
            cargarPopups();
        } catch {
            Swal.fire("Error", "No se pudo crear", "error");
        }
    };

    // ======================
    // RENDER
    // ======================
    return (
        <div className="container py-5">
            <div className="d-flex justify-content-between mb-3">
                <h4>Administración de PopUps</h4>
                <button className="btn btn-success" onClick={() => setShowCrear(true)}>
                    + Nuevo Popup
                </button>
            </div>

            {loading ? (
                <div className="text-center py-5">Cargando…</div>
            ) : (
                <div className="table-responsive bg-tabla-calculadora p-4">
                    <table className="table table-hover align-middle">
                        <thead className="bg-dark text-white text-center">
                            <tr>
                                <th>ID</th>
                                <th>Tipo</th>
                                <th>Inicio</th>
                                <th>Fin</th>
                                <th className="text-end">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {popups.map(p => (
                                <tr key={p.id} className="text-center">
                                    <td>{p.id}</td>
                                    <td>
                                        {editando === p.id ? (
                                            <select
                                                className="form-select form-select-sm"
                                                value={form.tipo}
                                                onChange={e => setForm({ ...form, tipo: e.target.value })}
                                            >
                                                <option value="PC">PC</option>
                                                <option value="TABLET">Tablet</option>
                                                <option value="CEL">Cel</option>
                                            </select>
                                        ) : (
                                            <span className="badge bg-secondary">{p.tipo}</span>
                                        )}
                                    </td>
                                    <td>
                                        {editando === p.id ? (
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={form.fechaInicio}
                                                onChange={e => setForm({ ...form, fechaInicio: e.target.value })}
                                            />
                                        ) : p.fechaInicio}
                                    </td>
                                    <td>
                                        {editando === p.id ? (
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={form.fechaFin}
                                                onChange={e => setForm({ ...form, fechaFin: e.target.value })}
                                            />
                                        ) : p.fechaFin}
                                    </td>
                                    <td className="text-end">
                                        {editando === p.id ? (
                                            <>
                                                <button className="btn btn-success btn-sm me-2" onClick={guardarEdicion}>Guardar</button>
                                                <button className="btn btn-secondary btn-sm" onClick={() => setEditando(null)}>Cancelar</button>
                                            </>
                                        ) : (
                                            <>
                                                <button className="btn btn-outline-primary btn-sm me-2" onClick={() => abrirEdicion(p)}>Editar</button>
                                                <button className="btn btn-outline-danger btn-sm" onClick={() => eliminarPopup(p.id)}>Eliminar</button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ================= MODAL CREAR ================= */}
            {showCrear && (
                <div className="popup-preview-overlay">
                    <div className="popup-preview-modal">
                        <button
                            className="popup-preview-close"
                            onClick={() => setShowCrear(false)}
                        >
                            ✕
                        </button>

                        <h5 className="mb-3">Nuevo Popup</h5>

                        {/* GRID: tipo + fechas */}
                        <div className="popup-form-grid">
                            <select
                                className="form-select"
                                value={tipoNuevo}
                                onChange={(e) => setTipoNuevo(e.target.value)}
                            >
                                <option value="pc">PC</option>
                                <option value="tablet">Tablet</option>
                                <option value="cel">Celular</option>
                            </select>

                            <input
                                type="date"
                                className="form-control"
                                value={fechaInicioNuevo}
                                onChange={(e) => setFechaInicioNuevo(e.target.value)}
                            />

                            <input
                                type="date"
                                className="form-control"
                                value={fechaFinNuevo}
                                onChange={(e) => setFechaFinNuevo(e.target.value)}
                            />
                        </div>

                        {/* FILE */}
                        <div className="popup-form-full">
                            <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </div>

                        {/* PREVIEW */}
                        {preview && (
                            <img
                                src={preview}
                                alt="Preview popup"
                                className="popup-preview-img"
                            />
                        )}

                        {/* BOTÓN */}
                        <button
                            className="btn btn-success popup-btn-crear mt-2"
                            onClick={crearPopup}
                        >
                            Crear Popup
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
}
